import { Injectable } from '@angular/core';
import { KRONOS } from '../../../app-constants';
import { API } from '../../../constants/index';
import { DataService } from '../core/interceptor.service';

@Injectable({
  providedIn: 'root'
})
export class FoodRegisterService {

  constructor(private dataService: DataService) { }

  getUserFoodStatus(req) {
    return this.dataService.post(KRONOS.BASE + KRONOS.FOOD + API.GET_USER_FOOD_STATUS, req);
  }

  getAllUsersFoodStatus(req) {
    return this.dataService.post(KRONOS.BASE + KRONOS.FOOD + API.GET_ALL_USERS_FOOD_STATUS, req);
  }

  foodBooking(req) {
    return this.dataService.post(KRONOS.BASE + KRONOS.FOOD + API.FOOD_BOOKING, req);
  }

  getSiteFoodBookingConfigByUser() {
    return this.dataService.get(KRONOS.BASE + API.GET_SITE_FOOD_BOOKING_SETTINGS_BY_USER)
  }

  getSiteWiseFoodBookingSettings() {
    return this.dataService.get(KRONOS.BASE + API.GET_SITE_WISE_FOOD_BOOKING_SETTINGS)
  }

  updateSiteFoodBookingSettings(siteId: string, req: any) {
    return this.dataService.put(KRONOS.BASE + 
      API.UPDATE_SITE_FOOD_BOOKING_SETTINGS
      .replace('{siteId}', siteId), req);
  }
}
